import axios from 'axios'

export const getSummaryTags = async () => {
  const url = `${process.env.REACT_APP_API}/tag/summary`
  const { data } = await axios.get(url)
  return data
}
